import router from "@/router";
import store from "@/store";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
  onMounted,
} from "@vue/composition-api";
import { resolveShortDate as resolveDateStr } from "@/utils/scripts/format-date";
import { templateType } from "@/configs/privilege/code-template";

import { Sortable, Swap } from "sortablejs";
Sortable.mount(new Swap());

export default function useTemplateComponent(props) {
  const vm = getCurrentInstance().proxy;

  const templateDataObj = reactive({
    templateId: null,
    templateType: null,
    logoImg: { file: null, url: null },
    privilegeImg: { file: null, url: null },
    backgroundImg: { file: null, url: null },
    privilegeName: null,
    privilegeDesc: null,
    privilegeTerm: null,
    expireDate: null,
    expireTime: null,
    expireDateStr: null,
    privilegeNameTextEditor: null,
    privilegeDescTextEditor: null,
    expTextEditor: null,
    privilegeTermEditor: null,
    templateContentWrp: [
      {
        text: "Coupon Name",
        style: [],
        seq: 0,
        keyApi: "privilege_name_texteditor",
        key: "privilegeNameTextEditor",
      },
      {
        text:
          "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum",
        style: [],
        seq: 1,
        keyApi: "description_texteditor",
        key: "privilegeDescTextEditor",
      },
      {
        text: "Expire Date",
        style: [],
        seq: 2,
        keyApi: "exp_texteditor",
        key: "expTextEditor",
      },
      {
        text: "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum",
        style: [],
        seq: 3,
        keyApi: "condition_htmleditor",
        key: "privilegeTermEditor",
      },
    ],
    colorCode: "#000000",
    isLayoutPrivilegeNameShow: true,
    isLayoutDescShow: true,
    isLayoutTermShow: true,
    isLayoutBgShow: true,
    isLayoutLogoShow: true,
    isExpire: true,
    colorCodeText: "#ffffff",

    privilegeUploadImg: { file: null, url: null },

    isLayoutRemarkShow: true,
    privilegeRemark: "Lorem ipsum Lorem ipsum Lorem",
    remarkTextEditer: null,
    remarkBgColor: "#dddfde",
  });

  const handleRowChange = (event) => {
    const elemId = templateDataObj.templateContentWrp.map((o) => o.key);
    const templateDiv = document.querySelector(
      `#template-type-${templateDataObj.templateType}`
    );
    let templateDivInner = templateDiv.getElementsByTagName("div");
    let templateDivInnerFilter = [];

    for (var i = 0; i < templateDivInner.length; i++) {
      if (templateDivInner[i].id !== "")
        templateDivInnerFilter.push(templateDivInner[i].id);
    }
    const templateListSeq = templateDivInnerFilter.filter((name1) =>
      elemId.find((name2) => name1 === name2)
    );

    if (templateListSeq.length > 0) {
      onReorderTemplate(templateListSeq);
    }
  };

  const onReorderTemplate = (event) => {
    vm.$nextTick(() => {
      vm.$emit("onReorder", event);
    });
  };

  const sortableOptions = reactive({
    swap: true,
    group: "shared",
    handle: ".reorder-template-content",
    filter: ".no-reorder",
    animation: 150,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
    onEnd: handleRowChange,
  });

  const initTemplateData = () => {
    vm.$nextTick(() => {
      const respData = props.templateData;

      templateDataObj.templateId = respData.templateId;
      templateDataObj.templateType = respData.templateSelect;
      templateDataObj.logoImg.file = respData.logoImg.file;
      templateDataObj.logoImg.url = respData.logoImg.url;
      templateDataObj.privilegeImg.file = respData.privilegeImg.img.file;
      templateDataObj.privilegeImg.url = respData.privilegeImg.img.url;
      templateDataObj.privilegeUploadImg.file = respData.privilegeImg.imgUpload.file;
      templateDataObj.privilegeUploadImg.url =  respData.privilegeImg.imgUpload.url;
      templateDataObj.backgroundImg.file = respData.backgroundImg.file;
      templateDataObj.backgroundImg.url = respData.backgroundImg.url;
      templateDataObj.privilegeName = respData.privilegeName;
      templateDataObj.privilegeDesc = respData.privilegeDesc;
      templateDataObj.privilegeTerm = respData.privilegeTerm;
      templateDataObj.expireDate = resolveDate;
      templateDataObj.expireTime = resolveTime;
      templateDataObj.expireDateStr = resolveExpireDate;
      templateDataObj.privilegeNameTextEditor =
        respData.privilegeNameTextEditor;
      templateDataObj.privilegeDescTextEditor =
        respData.privilegeDescTextEditor;
      templateDataObj.expTextEditor = respData.expTextEditor;
      templateDataObj.privilegeRemark = respData.privilegeRemark;
      templateDataObj.remarkTextEditer = respData.remarkTextEditer;
      templateDataObj.privilegeTermEditor = respData.privilegeTermEditor;
      templateDataObj.colorCode = respData.colorCode;
      templateDataObj.isLayoutPrivilegeNameShow =
        respData.isLayoutPrivilegeNameShow;
      templateDataObj.isLayoutDescShow = respData.isLayoutDescShow;
      templateDataObj.isLayoutRemarkShow = respData.isLayoutRemarkShow;
      templateDataObj.isLayoutTermShow = respData.isLayoutTermShow;
      templateDataObj.isLayoutBgShow = respData.isLayoutBgShow;
      templateDataObj.isLayoutLogoShow = respData.isLayoutLogoShow;
      templateDataObj.isExpire = respData.isExpire;
      templateDataObj.colorCodeText = respData.colorCodeText;

      templateDataObj.remarkBgColor = respData.remarkBgColor;

      var templateContentList = [];

      templateContentList.push(
        {
          text: templateDataObj.privilegeName,
          style: templateDataObj.privilegeNameTextEditor,
          seq: templateDataObj.privilegeNameTextEditor.seq,
          keyApi: "privilege_name_texteditor",
          key: "privilegeNameTextEditor",
          isShow: templateDataObj.isLayoutPrivilegeNameShow,
        },
        {
          text: templateDataObj.privilegeDesc,
          style: templateDataObj.privilegeDescTextEditor,
          seq: templateDataObj.privilegeDescTextEditor.seq,
          keyApi: "description_texteditor",
          key: "privilegeDescTextEditor",
          isShow: templateDataObj.isLayoutDescShow,
        },
        {
          text: templateDataObj.expireDateStr,
          style: templateDataObj.expTextEditor,
          seq: templateDataObj.expTextEditor.seq,
          keyApi: "exp_texteditor",
          key: "expTextEditor",
          isShow: templateDataObj.isExpire,
        },
        {
          text: templateDataObj.privilegeTerm,
          style: templateDataObj.privilegeTermEditor,
          seq: templateDataObj.privilegeTermEditor.seq,
          keyApi: "condition_htmleditor",
          key: "privilegeTermEditor",
          isShow: templateDataObj.isLayoutTermShow,
        }
      );

      templateDataObj.templateContentWrp = [...templateContentList].sort(
        (a, b) => a.seq - b.seq
      );
    });
  };

  const onSetSortableRow = (templateTypeSelect) => {
    let elemHeader = document.querySelector(
      `#template-type-${templateTypeSelect}.template-container .template-wrp .group-text-header`
    );
    let elemBody = document.querySelector(
      `#template-type-${templateTypeSelect}.template-container .template-wrp .group-text-body`
    );
    let elemFooter = document.querySelector(
      `#template-type-${templateTypeSelect}.template-container .template-wrp .group-text-footer`
    );

    if (
      templateTypeSelect == templateType.TYPE1 ||
      templateTypeSelect == templateType.TYPE4 ||
      templateTypeSelect == templateType.TYPE5
    ) {
      Sortable.create(elemBody, sortableOptions);
      Sortable.create(elemFooter, sortableOptions);
    } else {
      Sortable.create(elemHeader, sortableOptions);
      Sortable.create(elemBody, sortableOptions);
      Sortable.create(elemFooter, sortableOptions);
    }
  };

  const resolveExpireDate = computed(() => {
    if (templateDataObj.expireDate || templateDataObj.expireTime) {
      return `โค้ดหมดอายุวันที่ ${resolveDateStr(
        templateDataObj.expireDate,
        "-"
      ) || ""}`;
    }
  });

  const onSelect = (selectId, isRemove = false) => {
    vm.$nextTick(() => {
      vm.$emit("onSelectEditor", selectId, isRemove);
    });
  };

  const resolveDate = computed(() => {
    if (props.templateData.expireDate.date)
      return props.templateData.expireDate.date;
    return props.templateData.redeemDate.date || null;
  });

  const resolveTime = computed(() => {
    if (props.templateData.expireDate.time)
      return props.templateData.expireDate.time;
    return props.templateData.redeemDate.time || null;
  });

  const resolveRemarkStyle = (style) => {
    return {
      fontFamily: style?.fontName,
      textAlign: style?.fontAlign,
      fontSize: `${style?.fontSize}px`,
      color: style?.fontColor,
      fontWeight:
        style?.fontStyle.length > 0
          ? style?.fontStyle.find((o) => o == "bold")
          : "normal",
      fontStyle:
        style?.fontStyle.length > 0
          ? style?.fontStyle.find((o) => o == "italic")
          : "normal",
      textDecoration:
        style?.fontStyle.length > 0
          ? style?.fontStyle.find((o) => o == "underline")
          : null,
      lineHeight: parseFloat(style?.lineHeight),
    };
  };

  const resolveStyle = (templateObj) => {
    if (!templateObj) return;
    if (templateObj.style.length <= 0) return;

    return {
      fontFamily: templateObj.style?.fontName,
      textAlign: templateObj.style?.fontAlign,
      fontSize: `${templateObj.style?.fontSize}px`,
      color: templateObj.style?.fontColor,
      fontWeight:
        templateObj.style?.fontStyle.length > 0
          ? templateObj.style?.fontStyle.find((o) => o == "bold")
          : "normal",
      fontStyle:
        templateObj.style?.fontStyle.length > 0
          ? templateObj.style?.fontStyle.find((o) => o == "italic")
          : "normal",
      textDecoration:
        templateObj.style?.fontStyle.length > 0
          ? templateObj.style?.fontStyle.find((o) => o == "underline")
          : null,
      lineHeight: parseFloat(templateObj.style?.lineHeight),
    };
  };

  const resolveBgRemark = computed(() => {
    if (props.templateData.remarkBgColor)
      return props.templateData.remarkBgColor + "!important";
    else return "#dddfdb";
  });
  const resolveColor = computed(() => {
    if (props.templateData.colorCode) return props.templateData.colorCode;
  });

  const resolveTextColor = computed(() => {
    if (props.templateData.colorCodeText)
      return props.templateData.colorCodeText;
  });

  const fetchDetail = () => {
    if (props.templateData.templateId !== undefined) initTemplateData();
  };

  const getTemplateType = () => {
    if (router.currentRoute.query.templateType) {
      const templateType = parseInt(router.currentRoute.query.templateType);
      templateDataObj.templateType = templateType;
    }
  };

  onBeforeMount(() => {
    getTemplateType();
    fetchDetail();
  });

  onMounted(() => {
    if (templateDataObj.templateType)
      onSetSortableRow(templateDataObj.templateType);
  });

  watch(
    () => props.templateData,
    () => {
      fetchDetail();
    },
    { deep: true }
  );

  return {
    templateDataObj,
    resolveDate,
    resolveTime,
    onSelect,
    resolveStyle,
    resolveExpireDate,
    resolveColor,
    resolveTextColor,
    resolveBgRemark,
    resolveRemarkStyle,
  };
}
